module.exports = __webpack_public_path__ + "static/media/ic-educacao-fisica.ac39ca21.svg";